<template>
   <v-app>
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>Reset Password</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text>
                <v-alert :value="alert.show" dense outlined :type="alert.type" :icon="alert.icon">{{ alert.message }}</v-alert>
                <v-form ref="resetPasswordForm">
                  <v-row justify="center" align="center" dense>
                    <v-col cols="12">
                      <v-text-field id="email" label="Email" name="email" prepend-icon="email" type="text" v-model="user.email" :rules="[...getRlDialogRules.required, ...getRlDialogRules.email, ...getRlDialogRules.stringMax100]" maxlength="100" disabled />
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center" dense>
                    <v-col cols="12">
                      <v-text-field id="password" label="Password" name="password" prepend-icon="lock" type="password" v-model="user.password" autocomplete="new-password" :rules="passwordRules" maxlength="30" />
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center" dense>
                    <v-col cols="12">
                      <v-text-field id="password_conf" label="Password Confirmation" name="password" prepend-icon="lock" type="password" v-model="user.password_confirmation" :rules="passwordConfRules" maxlength="30" />
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary" @click.prevent="login()">Log in</v-btn>
                <v-spacer />
                <v-btn color="primary" @click.prevent="resetPassword()">Reset Password<v-icon>navigate_next</v-icon></v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-overlay :value="dialogLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-content>
   </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'

export default {
  name: 'ResetPassword',
  data() {
    return {
      user: {
        email: null,
        password: null,
        password_confirmation: null,
        token: null,
      },  
      alert: {show: false, type: null, icon: null, message: null},
      dialogLoading: false,
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v || '').length >= 8 || 'Minimum 8 characters',
        v => (v || '').length <= 30 || 'Maximum 30 characters'
      ],
      passwordConfRules: [
        v => !!v || 'Password confirmation is required',
        v => v === this.user.password || 'Password confirmation must match Password'
      ]
    }
  },
  mounted: function () {
      this.user.email = this.$route.query.email
      this.user.token = this.$route.query.token
  },
  methods: {
    login() {
      this.$router.push('/login');
    },
    async resetPassword() {
      try {
        if(this.$refs.resetPasswordForm.validate()) {
          this.dialogLoading = true

          await axios.get('sanctum/csrf-cookie')
          const response = await axios.post('api/v1/auth/resetPassword', { email: this.user.email, password: this.user.password, password_confirmation: this.user.password_confirmation, token: this.user.token })

          this.dialogLoading = false
  
          this.setLoginAlert({ show: true, type: "success", icon: "check_circle", message: response.data.message })
          this.$router.push('/login')
        }
      } catch (error) {
        this.dialogLoading = false
        this.alert = { show: true, type: "error", icon: "error", message: error.response.data.errors.email[0]}
      }
    },
    ...mapActions([
      'setLoginAlert'
    ])
  },
  computed: {
    ...mapGetters([
      'getRlDialogRules'
		])
  }
}
</script>